import React, { useEffect } from 'react';
import { UNIT_MIX_DEFAULT_NAME } from 'views/ProFormaWizard/constants';
import { TUnit } from '../types';

interface UseUnitManagerProps {
    unitArray: TUnit[];
    setUnitArray: React.Dispatch<React.SetStateAction<TUnit[]>>;
    initialUnits: TUnit[];
}

export const useUnitManager = ({ unitArray, setUnitArray, initialUnits }: UseUnitManagerProps) => {
    const defaultUnit = {
        name: UNIT_MIX_DEFAULT_NAME,
        averageSquareFootage: 0,
        amountPerMonth: 0,
        units: 0,
        totalRent: 0,
    };

    const handleDuplicateOrAdd = (unitId?: number) => {
        const lowestNegativeId = unitArray.reduce((min, unit) => (unit.id < min ? unit.id : min), 0);

        const newId = lowestNegativeId > 0 ? -1 : lowestNegativeId - 1;

        if (unitId) {
            const unitToDuplicate = unitArray.find(unit => unit.id === unitId);
            if (unitToDuplicate) {
                setUnitArray([...unitArray, { ...unitToDuplicate, id: newId }]);
            }
        } else {
            setUnitArray([...unitArray, { ...defaultUnit, id: newId }]);
        }
    };

    const handleDelete = (unitId: number) => {
        setUnitArray(prev => prev.filter(unit => unit.id !== unitId));
    };

    const handleUpdate = (updatedUnit: TUnit) => {
        setUnitArray(prev => prev.map(unit => (unit.id === updatedUnit.id ? updatedUnit : unit)));
    };

    useEffect(() => {
        if (initialUnits.length > 0) {
            const newUnits = initialUnits.map(unit => ({
                ...unit,
                id: unit.id,
                name: unit.name,
                averageSquareFootage: Number(unit.averageSquareFootage) || 0,
                amountPerMonth: Number(unit.amountPerMonth) || 0,
                units: Number(unit.units) || 0,
                totalRent: Number(unit.totalRent) || 0,
            }));
            setUnitArray(newUnits);
        } else {
            setUnitArray([{ ...defaultUnit, id: -1 }]);
        }
    }, [initialUnits]);

    return {
        unitArray,
        handleDuplicateOrAdd,
        handleDelete,
        handleUpdate,
        setUnitArray,
    };
};
